import { env } from 'src/env.mjs';
import { PlansRequest } from 'src/hooks/Plans/usePlans';

const apiPath = env.NEXT_PUBLIC_API_PATH; // Get the base path from the environment variables.

export default {
    RENEWAL_QUIZZES_START_QUIZ: `${apiPath}/api/v2/renewal_quizzes/start_quiz`,
    RENEWAL_QUIZZES_SUBMIT_ANSWER: `${apiPath}/api/v2/renewal_quizzes/submit_answer`,
    INITIAL_QUIZZES_START_QUIZ: `${apiPath}/api/v2/initial_quizzes/start_quiz`,
    INITIAL_QUIZZES_SUBMIT_ANSWER: `${apiPath}/api/v2/initial_quizzes/submit_answer`,
    INITIAL_CONSENT_PROGRESS: (quizToken: string) =>
        `${apiPath}/api/v2/initial_consents/progress?quizToken=${quizToken}`,
    INITIAL_CONSENT_COMPLETE_STEP: `${apiPath}/api/v2/initial_consents/complete_step`,
    HEALTH_TRACKING_QUIZZES_START_QUIZ: `${apiPath}/api/v2/health_tracking_quizzes/start_quiz`,
    HEALTH_TRACKING_QUIZZES_SUBMIT_ANSWER: `${apiPath}/api/v2/health_tracking_quizzes/submit_answer`,
    USER: (uuid: string) => `${apiPath}/api/v2/users/${uuid}`,
    APPLE_LOGIN: `${apiPath}/api/v2/tokens/request/apple`,
    GOOGLE_LOGIN: `${apiPath}/api/v2/tokens/request/google`,
    PAYMENT: (
        paymentType:
            | 'card_payment'
            | 'initialize_paypal'
            | 'initialize_afterpay'
            | 'initialise_payment_intent'
            | 'finalise_payment_intent',
    ) => `${apiPath}/api/v2/payments/${paymentType}`,
    CONSULT_CALCULATE_WAIT_TIME: (quizToken: string, timezone: string) =>
        `${apiPath}/api/v2/callbacks/calculate_wait_time/${quizToken}?timezone=${timezone}`,
    CONSULT_ADD_TO_QUEUE: `${apiPath}/api/v2/callbacks/add_to_queue`,
    ADDRESS_HDS_VALIDATE: (
        suburb: string,
        postcode: string,
        quizToken: string,
    ) => {
        const params = new URLSearchParams({ suburb, postcode, quizToken });

        return `${apiPath}/api/v2/addresses/hds_validate?${params.toString()}`;
    },
    APPLE_CALLBACK: `${apiPath}/api/v2/tokens/apple/callback`,
    MEDICAL_SUPPORT_TICKET_LIST: (uuid: string, pageType, page) =>
        `${apiPath}/api/v2/users/${uuid}/medical_support/ticket_list?type=${pageType}&page=${page}`,
    MEDICAL_SUPPORT_CREATE_TICKET: (uuid: string) =>
        `${apiPath}/api/v2/users/${uuid}/medical_support`,
    MEDICAL_SUPPORT_TICKET: (uuid: string, token: string) =>
        `${apiPath}/api/v2/users/${uuid}/medical_support/${token}`,
    MEDICAL_SUPPORT_TICKET_MESSAGE: (uuid: string) =>
        `${apiPath}/api/v2/users/${uuid}/medical_support/create_message`,
    MEDICATIONS: (uuid: string) =>
        `${apiPath}/api/v2/users/${uuid}/medications`,
    MEDICATION: (uuid: string, medicationId: string) =>
        `${apiPath}/api/v2/users/${uuid}/medications/${medicationId}`,
    MEDICATION_ARTICLES: (uuid: string, medicationId: string) =>
        `${apiPath}/api/v2/users/${uuid}/medications/${medicationId}/articles`,
    MEDICATION_STEP: (uuid: string, medicationId: string, stepId: string) =>
        `${apiPath}/api/v2/users/${uuid}/medications/${medicationId}/step/${stepId}`,
    LOGIN: `${apiPath}/api/v2/tokens/request`,
    LOGOUT: `${apiPath}/api/v2/tokens/revoke`,
    VERIFY_EMAIL: `${apiPath}/api/v2/users/verify_email`,
    VERIFY_PHONE: `${apiPath}/api/v2/users/verify_phone`,
    CREATE_ACCOUNT: `${apiPath}/api/v2/users`,
    POSTCODE_SEARCH: (query: string) => {
        const params = new URLSearchParams({ query });

        return `${apiPath}/api/v2/addresses/postcode_search?${params.toString()}`;
    },
    // User
    RESET_PASSWORD_EMAIL: `${apiPath}/api/v2/tokens/reset_password_email`,
    CREATE_PASSWORD: `${apiPath}/api/v2/tokens/create_password`,
    RESET_PASSWORD_TOKEN_VALID: `${apiPath}/api/v2/tokens/reset_password_token_valid`,
    ADDRESS_VALIDATION: (
        address: string,
        suburb: string,
        postcode: string,
        planId?: string,
    ) =>
        `${apiPath}/api/v2/addresses/address_validation?shipping_address=${address}&suburb=${suburb}&postcode=${postcode}&plan_id=${planId}`,
    UPDATE_USER_CONTACT_PREFERENCES: `${apiPath}/api/v2/users/update_contact_preferences`,

    // Checkout
    PLAN_CONFIGURATION: `${apiPath}/api/v2/plans/configuration`,
    PLANS: (params: PlansRequest) =>
        `${apiPath}/api/v2/plans?${params.planIds.map((id) => `plan_ids[]=${id}`).join(';')}`,
    RENEWAL_PLAN_CHANGE: (quizToken: string) =>
        `${apiPath}/api/v2/renewal_quizzes/plan_change?quizToken=${quizToken}`,
    RENEWAL_CONSENT: `${apiPath}/api/v2/renewal_quizzes/consent`,
    RENEWAL_CONSENT_CONTENT: (quizToken: string) =>
        `${apiPath}/api/v2/renewal_quizzes/consent_content?quizToken=${quizToken}`,
    RENEWAL_PLAN_CHANGE_ACCEPT: `${apiPath}/api/v2/renewal_quizzes/plan_change/accept_plan_change`,

    // Plans
    DOCTOR_PLANS: (quizToken: string) =>
        `${apiPath}/api/v2/doctor_plans/${quizToken}`,
    PLAN_FEEDBACK: (plan_id: string) =>
        `${apiPath}/api/v2/plan_feedbacks?plan_id=${plan_id}`,
    USER_HEALTH_TRACKING_GET: (
        uuid: string,
        variables: string[] | boolean[] | number[],
    ) =>
        `${apiPath}/api/v2/users/${uuid}/health_tracking${
            variables.length
                ? `?variable[]=${variables.join('&variable[]=')}`
                : ''
        }`,
};
